import React, { useState } from 'react'
import { XMarkIcon, ChatBubbleLeftEllipsisIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import FormularzZgloszenia from './FormularzZgloszenia'
import { useDostepDoTresci } from './auth/BramkaLogowania'

/**
 * Zachęta do zgłaszania błędów — stale w lewym dolnym rogu.
 *
 * PO CO: platforma jest w rozwoju i większość usterek znajdą użytkownicy, a nie
 * my. Zgłoszenie musi być możliwe DOKŁADNIE w chwili, gdy ktoś coś zobaczy —
 * osobna strona kontaktowa oznacza, że do zgłoszenia nigdy nie dojdzie.
 *
 * ═══ FORMULARZ ZAMIAST ADRESU (decyzja właściciela 2026-10-13) ═══
 * Do 2026-10-13 był tu sam adres e-mail, świadomie bez formularza: formularz wymagał endpointu, ochrony
 * przed botami i miejsca, gdzie zgłoszenia lądują, a dopóki nikt ich nie czytał, sprawiałby wrażenie, że
 * zgłoszenie gdzieś trafia, i gubił je po cichu.
 * Teraz właściciel chce okienka na wiadomość do 1000 znaków, które wysyła się samo. Te same obawy są
 * zaadresowane: wiadomość idzie MAILEM na kontakt@voltvalue.pl (czytana skrzynka, bez nowej tabeli),
 * backend ma honeypot i limity (`accounts/zgloszenie_bledu.py`), a gdy wysyłka padnie, formularz zostawia
 * tekst i pokazuje adres do skopiowania. Ten sam formularz otwiera ostatnia pozycja menu konta.
 *
 * ═══ DLACZEGO LEWY DOLNY RÓG ═══
 * Prawy zajmuje porównywarka (`CompareWidget`, `right-6 bottom-6`). Na wąskim
 * ekranie porównywarka rozkłada się na pasek przy dolnej krawędzi, więc tam
 * podnosimy kafelek wyżej, żeby nie nachodziły na siebie.
 *
 * DOMYŚLNIE ZWINIĘTY (decyzja właściciela 2026-10-09): mały przycisk „Zgłoś błąd” z dymkiem; kafelek z formularzem
 * rozwija się po kliknięciu. Rozwinięty kafelek nad treścią przy każdej wizycie był przeszkodą.
 */

const ZglosBlad = () => {
  const { t } = useTranslation('wspolne')
  const [zwiniete, setZwiniete] = useState(true)
  const zwin = () => setZwiniete(true)
  const rozwin = () => setZwiniete(false)

  // `bottom-24` na wąskim ekranie: tyle zajmuje pasek porównywarki przy dolnej
  // krawędzi. Na `md` porównywarka wraca do prawego rogu i kafelek może zejść niżej.
  // W Projekcie 3D przy dolnej krawędzi stoi pasek czasu (wschód, zachód, odtwarzanie), więc przycisk idzie nad niego.
  const { pathname } = useLocation()
  // Bez logowania na /projekt-3d jest tylko ekran zachęty (bramka `projekt3d`, 2026-10-15), bez paska czasu.
  const { odblokowane: projekt3dOtwarty } = useDostepDoTresci('projekt3d')
  const nadPaskiem = pathname.replace(/\/+$/, '') === '/projekt-3d' && projekt3dOtwarty
  const POZYCJA = `fixed z-40 print:hidden ${nadPaskiem ? 'left-4 bottom-44 md:left-6 md:bottom-32' : 'left-4 bottom-24 md:left-6 md:bottom-6'}`

  if (zwiniete) {
    return (
      <button
        type="button"
        onClick={rozwin}
        className={`${POZYCJA} inline-flex items-center gap-2 px-3.5 py-2.5 rounded-full
                    bg-white border border-gray-200 shadow-lg text-sm font-medium
                    text-gray-600 hover:text-blue-700 hover:border-blue-300 transition-colors`}
      >
        <ChatBubbleLeftEllipsisIcon className="w-5 h-5" />
        {t('zglos.przycisk')}
      </button>
    )
  }

  return (
    <div
      className={`${POZYCJA} w-[21rem] max-w-[calc(100vw-2rem)] rounded-xl
                  bg-white border border-gray-200 shadow-xl p-4`}
      role="complementary"
      aria-label={t('zglos.aria')}
    >
      <button
        type="button"
        onClick={zwin}
        aria-label={t('zglos.zwin')}
        className="absolute top-2 right-2 p-1 rounded-lg text-gray-400
                   hover:text-gray-700 hover:bg-gray-100 transition-colors"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>

      <p className="flex items-center gap-2 text-sm font-bold text-gray-900 pr-6">
        <ChatBubbleLeftEllipsisIcon className="w-5 h-5 text-blue-600 flex-shrink-0" />
        {t('zglos.tytul')}
      </p>

      <p className="mt-1.5 text-xs text-gray-500 leading-5">
        {t('zglos.opis')}
      </p>

      <FormularzZgloszenia onZamknij={zwin} />
    </div>
  )
}

export default ZglosBlad
